// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__x24aL","panel":"Accordion_panel__jCh2z"};